module.exports = __webpack_public_path__ + "img/render.ebc90445.jpg";